export function NoActionRequiredIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      className="stroke-foreground"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 34L28 40L42 26"
        stroke="current"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z"
        stroke="current"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
